// @ts-ignore

const countries = [
    {
        id: "РОССИЯ",
        name: "РОССИЯ",
        currency: "Российский рубль"
    },
    {
        id: "АРМЕНИЯ",
        name: "АРМЕНИЯ",
        currency: "Армянский драм"
    },
    {
        id: "БЕЛАРУСЬ",
        name: "БЕЛАРУСЬ",
        currency: "Белорусский рубль"
    },
    {
        id: "АБХАЗИЯ",
        name: "АБХАЗИЯ",
        currency: "Российский рубль"
    },
    {
        id: "КАЗАХСТАН",
        name: "КАЗАХСТАН",
        currency: "Казахстанский тенге"
    },
    {
        id: "КЫРГЫЗСТАН",
        name: "КЫРГЫЗСТАН",
        currency: "Киргизский сом"
    },
    {
        id: "УЗБЕКИСТАН",
        name: "УЗБЕКИСТАН",
        currency: "Узбекский сум"
    },
    {
        id: "АЗЕРБАЙДЖАН",
        name: "АЗЕРБАЙДЖАН",
        currency: "Азербайджанский манат"
    },
    {
        id: "ТАДЖИКИСТАН",
        name: "ТАДЖИКИСТАН",
        currency: "Таджикский сомони"
    }
];


export default countries;
